var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.displayRoleSelector
        ? _c(
            "v-layout",
            {
              attrs: {
                row: "",
                wrap: "",
                "justify-space-between": "",
                "ml-4": "",
                "mr-3": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", md3: "" } },
                [
                  _c("sub-navigation-title-duplicate", {
                    attrs: {
                      "is-icon": true,
                      icon: "people_outline",
                      "load-more-visible": false,
                      title: _vm.coCurrentEntityName,
                      source: _vm.coEntities
                    },
                    on: { click: _vm.handleEntityClick },
                    model: {
                      value: _vm.dtMenu,
                      callback: function($$v) {
                        _vm.dtMenu = $$v
                      },
                      expression: "dtMenu"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "block--contacts ml-4 mr-3 mt-3",
          attrs: { flat: "", color: "transparent" }
        },
        [
          _c(
            "v-data-table",
            {
              staticClass:
                "dr-table--transparent dr-table__profile elevation-2",
              attrs: {
                headers: _vm.coTableHeaders,
                items: _vm.coSource,
                "hide-actions": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c(
                        "tr",
                        {
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function(e) {
                              return _vm.handleMemberClick(props.item.id)
                            }
                          }
                        },
                        [
                          _c(
                            "td",
                            { staticClass: "primary--text" },
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    color: "primary",
                                    color: _vm.isMemberSelected(props.item.id)
                                      ? "#2E038C !important"
                                      : "#eee !important"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.handleAvatarClick(props.item.id)
                                    }
                                  }
                                },
                                [
                                  props.item.avatar
                                    ? _c("img", {
                                        attrs: { src: props.item.avatar }
                                      })
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "headline",
                                          class: {
                                            "white--text": _vm.isMemberSelected(
                                              props.item.id
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("acronym")(
                                                  props.item.fullname
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.coTableLoader
                            ? _c("td", { staticClass: "primary--text" }, [
                                _c(
                                  "span",
                                  { staticClass: "primary--text__head" },
                                  [
                                    _c("b", [
                                      _vm._v(_vm._s(props.item.fullname))
                                    ])
                                  ]
                                )
                              ])
                            : _c(
                                "td",
                                { staticClass: "primary--text" },
                                [
                                  _c("profile-table-loader", {
                                    attrs: { "loader-type": "multi-column" }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          !_vm.coTableLoader
                            ? [
                                _c("td", { staticClass: "primary--text" }, [
                                  _vm._v(_vm._s(props.item.email))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "primary--text",
                                    class: {
                                      "empty--column": !props.item.landline
                                    }
                                  },
                                  [_vm._v(_vm._s(props.item.landline || "-"))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "primary--text",
                                    class: {
                                      "empty--column": !props.item.cellphone
                                    }
                                  },
                                  [_vm._v(_vm._s(props.item.cellphone || "-"))]
                                )
                              ]
                            : [
                                _c(
                                  "td",
                                  { staticClass: "primary--text" },
                                  [
                                    _c("profile-table-loader", {
                                      attrs: { "loader-type": "column" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "primary--text" },
                                  [
                                    _c("profile-table-loader", {
                                      attrs: { "loader-type": "column" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "primary--text" },
                                  [
                                    _c("profile-table-loader", {
                                      attrs: { "loader-type": "column" }
                                    })
                                  ],
                                  1
                                )
                              ],
                          _vm._v(" "),
                          !_vm.coTableLoader
                            ? _c(
                                "td",
                                { staticClass: "primary--text px-0" },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "actions--wrapper",
                                      attrs: { "pr-4": "", "justify-end": "" }
                                    },
                                    [
                                      _vm.canEditContact(props.item)
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "pr-2 primary--text__action pa-0 ma-0",
                                              attrs: { text: "", flat: "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.handleEditContact(
                                                    props.item.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pr-1",
                                                  attrs: { small: "" }
                                                },
                                                [_vm._v("edit")]
                                              ),
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting.profileEdit
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  }
                }
              ])
            },
            [
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t(_vm.lblSetting.profileTableNoData)) +
                    "\n          "
                )
              ]
            ],
            2
          ),
          _vm._v(" "),
          _vm.dtTotalPage > 1 && !_vm.coTableLoader
            ? _c("base-paginator", {
                attrs: { total: _vm.dtTotalPage },
                model: {
                  value: _vm.dtPage,
                  callback: function($$v) {
                    _vm.dtPage = $$v
                  },
                  expression: "dtPage"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleCloseErrorModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc27c018", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27c018","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-tenants/template.html
// module id = null
// module chunks = 